import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../Layout/Grid/Cell/Default/EnumCell";
import { plantTypeAsString } from "../PlantType";

export const plantTypeEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={plantTypeAsString} />
);

export const plantTypeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { PlantType: "PTO" },
      { PlantType: "IEO" },
      { PlantType: "Transmission" },
      { PlantType: "Blue Oval" },
      { PlantType: "ILLP" },
    ]}
    searchBox={() => null}
    {...props}
  />
);
